<template>
<div :class="['px-6 py-8 min-h-screen transition-colors duration-300', themeMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-100 text-gray-800']">
    <!-- 🏫 Periodo Escolar al inicio, centrado y elegante -->
    <div class="w-full mb-6 flex justify-center">
        <div class="inline-flex items-center px-6 py-3 rounded-xl shadow-lg border transition-all duration-300" :class="themeMode
      ? 'bg-indigo-800 border-indigo-600 '
      : 'bg-indigo-500 border-indigo-400 '">
            <ion-icon name="calendar-outline" class="mr-2 text-2xl"></ion-icon>
            <span class="text-lg font-bold tracking-wide">
                Periodo Escolar:
                <span class="ml-1 font-semibold">
                    {{ (periodoSeleccionado && periodoSeleccionado.descripcion_periodoescolar) || 'Sin periodo asignado' }}
                </span>
            </span>
        </div>
    </div>
    <!-- Sección Unificada de Institución y Fichero -->
    <div>
        <!-- Header con Información de Institución y Acciones -->
        <div class="flex flex-col md:flex-row md:justify-between md:items-center mb-6">
            <div class="flex items-center space-x-3">
                <ion-icon name="business-outline" class="text-2xl text-primary"></ion-icon>
                <div>
                    <h2 class="text-2xl font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">
                        {{ institucionSeleccionada.nombreInstitucion }}
                    </h2>
                    <p class="text-sm transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">ID: {{ institucionSeleccionada.idInstitucion }}</p>
                </div>
            </div>

            <!-- Botones de Acciones -->
            <div class="flex flex-wrap gap-3 mt-4 md:mt-0 justify-center md:justify-end" align="center">
                <!-- Crear Fichero -->
                <vs-button v-if="!tieneficheroExistente || Fichero_Array.length === 0" @click="abrirOpcionesCreacion()" color="success" type="filled" icon-pack="feather" icon="icon-plus" class="px-4 py-2 font-medium">
                    Crear Fichero de Mercado
                </vs-button>

                <!-- Editar / Visualizar / Enviar / Permitir -->
                <template v-else>
                    <vs-button v-if="(userRoot) || (userAsesor && Fichero_Array[0].fm_estado == 1) || (userAsesor && Fichero_Array[0].fm_estado == 4)" @click="verificarcrear_actualizar = 'editar'; Actualizar_Fichero()" color="warning" type="filled" icon-pack="feather" icon="icon-edit" class="px-4 py-2 font-medium">
                        Editar Fichero
                    </vs-button>
                    <vs-button @click="Visualizar_Fichero()" color="primary" type="filled" icon-pack="feather" icon="icon-eye" class="px-4 py-2 font-medium">
                        Ver Fichero
                    </vs-button>
                    <vs-button v-if="(userRoot) || (userAsesor && Fichero_Array[0].fm_estado == 1)" @click="Eliminar_Fichero()" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" class="px-4 py-2 font-medium">
                        Eliminar Fichero
                    </vs-button>
                    <!-- <vs-button v-if="Fichero_Array[0].fm_estado == 1 || Fichero_Array[0].fm_estado == 4" @click="EnviarParaAprobacion()" color="success" type="filled" icon-pack="feather" icon="icon-send" class="px-4 py-2 font-medium">
                        Enviar para Aprobación
                    </vs-button> -->

                    <!-- <vs-button v-if="(Fichero_Array[0].fm_estado == 2 || Fichero_Array[0].fm_estado == 3) && userRoot" @click="Cambio_Estado_Activo()" color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-send" class="px-4 py-2 font-medium">
                        Permitir que el asesor edite
                    </vs-button> -->
                </template>
            </div>
        </div>

        <!-- Detalles de la Institución -->
        <h3 class="text-lg font-medium mb-4 transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-700'">Detalles de la Institución</h3>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <!-- Columna Izquierda -->
            <div class="space-y-3">
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Nombre:</strong> {{ institucionSeleccionada.nombreInstitucion }}</p>
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Provincia:</strong> {{ institucionSeleccionada.nombreprovincia || 'No especificada' }}</p>
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Ciudad:</strong> {{ institucionSeleccionada.nombre_ciudad || 'No especificada' }}</p>
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Parroquia:</strong> {{ institucionSeleccionada.parr_nombre || 'No especificada' }}</p>
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Dirección:</strong> {{ institucionSeleccionada.direccionInstitucion || 'No especificada' }}</p>
                <p v-if="institucionSeleccionada.email || institucionSeleccionada.correo">
                    <strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Email:</strong> {{ institucionSeleccionada.email || institucionSeleccionada.correo }}
                </p>
            </div>
            <!-- Columna Derecha -->
            <div class="space-y-3">
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">ID Institución:</strong> {{ institucionSeleccionada.idInstitucion }}</p>
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">RUC:</strong> {{ institucionSeleccionada.ruc || 'No especificado' }}</p>
                <p><strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Estado:</strong> {{ institucionSeleccionada.estado_idEstado == 1 ? 'Activo' : 'Inactivo' }}</p>
                <p v-if="institucionSeleccionada.telefonoInstitucion || institucionSeleccionada.telefono">
                    <strong :class="themeMode ? 'text-gray-300' : 'text-gray-600'">Teléfono:</strong> {{ institucionSeleccionada.telefonoInstitucion || institucionSeleccionada.telefono }}
                </p>
            </div>
        </div>

        <!-- Sección de Fichero de Mercado (integrada y mejorada) -->
        <div class="flex items-center mb-4">
            <ion-icon name="document-outline" class="text-xl text-primary mr-2"></ion-icon>
            <h3 class="text-lg font-medium transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-700'">Información del Fichero de Mercado</h3>
        </div>

        <div v-if="tieneficheroExistente && Fichero_Array.length > 0" :class="['p-6 rounded-lg border transition-colors duration-300', themeMode ? 'bg-gray-700 border-gray-600' : 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200']">
            <!-- 🧾 Sección de Datos Generales -->
            <h4 class="text-lg font-semibold mb-4 transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-700'">Datos del Fichero</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Columna Izquierda: ID y Estado -->
                <div class="space-y-4">
                    <!-- ID -->
                    <div :class="['flex items-center space-x-3 p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                        <ion-icon name="id-card-outline" class="text-lg text-blue-500"></ion-icon>
                        <div>
                            <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">FM ID</p>
                            <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">{{ Fichero_Array[0].fm_id }}</p>
                        </div>
                    </div>
                    <!-- Estado -->
                    <div :class="['flex items-center space-x-3 p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                        <ion-icon name="toggle-outline" class="text-lg text-green-500"></ion-icon>
                        <div>
                            <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">Estado</p>
                            <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">
                                {{
                                    Fichero_Array.length > 0
                                        ? (Fichero_Array[0].fm_estado == 1 ? 'Creado/Activo'
                                          : Fichero_Array[0].fm_estado == 2 ? 'Enviado para aprobación'
                                          : Fichero_Array[0].fm_estado == 0 ? 'Inactivo'
                                          : Fichero_Array[0].fm_estado == 3 ? 'Aprobado'
                                          : Fichero_Array[0].fm_estado == 4 ? 'Devuelto'
                                          : 'Estado desconocido')
                                        : 'No hay fichero'
                                }}
                            </p>
                            <!-- ⚠️ Mensaje adicional si el estado es 3 -->
                            <div v-if="Fichero_Array.length > 0 && Fichero_Array[0].fm_estado == 2">
                                <p v-if="userRoot" class="text-yellow-600 text-sm mt-1 items-center gap-1">
                                    ⚠️ Debe aprobar o devolver el fichero en la sección <b>'Ver Fichero'</b>.
                                </p>
                                <p v-if="userAsesor" class="text-yellow-600 text-sm mt-1 items-center gap-1">
                                    ⏳ En proceso de aprobación.
                                </p>
                            </div>
                            <div v-if="Fichero_Array.length > 0 && Fichero_Array[0].fm_estado == 3" class="text-green-600 text-sm mt-1 items-center gap-1">
                                ✅ Esta institución se encuentra habilitada para realizar su pedido, pero puede devolver el fichero al asesor en la sección <b>'Ver Fichero'</b> para que pueda corregirlo.
                            </div>
                            <div v-if="Fichero_Array.length > 0 && Fichero_Array[0].fm_estado == 1" class="text-green-600 text-sm mt-1 items-center gap-1">
                                📤 Por favor, revise que toda la información esté completa y luego <b>envíe el fichero para aprobación</b> en la sección <b>'Ver Fichero'</b>.
                            </div>
                            <div v-if="Fichero_Array.length > 0 && Fichero_Array[0].fm_estado == 4" class="text-green-600 text-sm mt-1 items-center gap-1">
                                ⚠️ Por favor, revise que toda la información esté corregida y luego envíe el fichero para <b>aprobación</b> en la sección <b>'Ver Fichero'</b>.
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Columna Derecha: Observaciones -->
                <div class="space-y-4">
                    <div :class="['p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                        <p class="text-sm font-medium uppercase tracking-wide mb-2 transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">Observaciones</p>
                        <p class="transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-700'">{{ Fichero_Array[0].fm_observacion || 'Sin observaciones' }}</p>
                    </div>
                </div>
            </div>

            <!-- 🕓 Sección de Fechas y Usuarios -->
            <h4 class="text-lg font-semibold mt-8 mb-4 transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-700'">Fechas y Usuarios</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Fecha de Creación -->
                <div :class="['flex items-center space-x-3 p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                    <ion-icon name="calendar-outline" class="text-lg text-purple-500"></ion-icon>
                    <div>
                        <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">Fecha de Creación</p>
                        <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">{{ Fichero_Array[0].created_at }}</p>
                        <p class="text-sm transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-600'">{{ Fichero_Array[0].usercreated_nombres }} {{ Fichero_Array[0].usercreated_apellidos }}</p>
                    </div>
                </div>

                <!-- Última Actualización -->
                <div :class="['flex items-center space-x-3 p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                    <ion-icon name="refresh-outline" class="text-lg text-orange-500"></ion-icon>
                    <div>
                        <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">Última Actualización</p>
                        <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">{{ Fichero_Array[0].updated_at }}</p>
                        <p class="text-sm transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-600'">{{ Fichero_Array[0].user_edit_nombres }} {{ Fichero_Array[0].user_edit_apellidos }}</p>
                    </div>
                </div>
            </div>

            <!-- 🧭 Sección de Seguimiento -->
            <h4 v-if="Fichero_Array[0].fm_estado == 2 || Fichero_Array[0].fm_estado == 3 || Fichero_Array[0].fm_estado == 4" class="text-lg font-semibold mt-8 mb-4 transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-700'">Seguimiento del Fichero</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Enviado para Aprobación -->
                <div v-if="Fichero_Array[0].fm_estado >= 2" :class="['flex items-center space-x-3 p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                    <ion-icon name="send-outline" class="text-lg text-blue-500"></ion-icon>
                    <div>
                        <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">Enviado para Aprobación</p>
                        <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">
                            {{ Fichero_Array[0].user_envia_nombres || '---' }} {{ Fichero_Array[0].user_envia_apellidos || '' }}
                        </p>
                        <p class="text-sm transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-600'">Fecha: {{ Fichero_Array[0].fecha_envio_aprobacion || '---' }}</p>
                    </div>
                </div>

                <!-- Aprobación -->
                <div v-if="Fichero_Array[0].fm_estado == 3" :class="['flex items-center space-x-3 p-3 rounded-md shadow-sm border transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                    <ion-icon name="checkmark-done-outline" class="text-lg text-green-500"></ion-icon>
                    <div>
                        <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">Aprobado por</p>
                        <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">
                            {{ Fichero_Array[0].user_aprobacion_nombres || '---' }} {{ Fichero_Array[0].user_aprobacion_apellidos || '' }}
                        </p>
                        <p class="text-sm transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-600'">Fecha: {{ Fichero_Array[0].fecha_aprobacion || '---' }}</p>
                    </div>
                </div>

                <!-- Rechazo -->
                <div v-if="Fichero_Array[0].fm_estado == 4" :class="['flex flex-col space-y-2 p-4 rounded-md border shadow-sm transition-colors duration-300',themeMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-100']">
                    <div class="flex items-center space-x-3">
                        <ion-icon name="close-circle-outline" class="text-2xl text-red-500"></ion-icon>
                        <div>
                            <p class="text-sm font-medium uppercase tracking-wide transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-500'">
                                Devuelto por
                            </p>
                            <p class="text-lg font-semibold transition-colors duration-300" :class="themeMode ? 'text-gray-100' : 'text-gray-800'">
                                {{ Fichero_Array[0].user_rechazo_nombres || '---' }}
                                {{ Fichero_Array[0].user_rechazo_apellidos || '' }}
                            </p>
                            <p class="text-sm transition-colors duration-300" :class="themeMode ? 'text-gray-400' : 'text-gray-600'">
                                Fecha: {{ Fichero_Array[0].fecha_rechazo || '---' }}
                            </p>
                        </div>
                    </div>
                    <!-- Observación / Comentario del rechazo -->
                    <div class="pl-9 border-l-4 mt-3 transition-colors duration-300" :class="themeMode ? 'border-red-600' : 'border-red-500'">
                        <p class="text-sm font-semibold mb-1 transition-colors duration-300" :class="themeMode ? 'text-red-400' : 'text-red-600'">
                            Observación:
                        </p>
                        <p class="text-sm italic transition-colors duration-300" :class="themeMode ? 'text-gray-300' : 'text-gray-700'">
                            "{{ Fichero_Array[0].comentario_rechazo || 'Sin comentario registrado.' }}"
                        </p>
                    </div>

                </div>

            </div>
        </div>

        <!-- Mensaje cuando no hay fichero -->
        <div v-else :class="['p-6 rounded-lg border text-center transition-colors duration-300', themeMode ? 'bg-gray-800 border-gray-700 text-gray-200' : 'bg-gray-50 border-gray-200 text-gray-500']">
            <p class="text-lg font-medium">{{ 'Aún no se ha creado o registrado un fichero de mercado.' }}</p>
            <p class="text-sm mt-2">{{ 'Puedes crear uno nuevo usando el botón "Crear Fichero de Mercado".' }}</p>
        </div>
    </div>

    <!-- Popups (Dark Mode aplicado) -->
    <vs-popup class="informacionformhijo hide-close" fullscreen @close="cerrarPopupFicheroMercado()" :title="verificarcrear_actualizar == 'crear' ? 'Crear nuevo fichero' : `Actualizar fichero de la institución: ${institucionSeleccionada.nombreInstitucion || ''}`" :active.sync="popupFicheroMercado">
        <!-- Botón de cerrar custom -->
        <button @click="cerrarPopupFicheroMercado(true)" class="custom-popup-close">✕</button>
        <Nuevo_Edit_FicheroMercado v-if="popupFicheroMercado" :periodoSeleccionado="periodoSeleccionado" :verificarcrear_actualizar="verificarcrear_actualizar" :institucion_Enviar="institucionSeleccionada" :Fichero_Array="Fichero_Array" @change="changeHandleNuevoActualizar_FicheroMercado" />
    </vs-popup>
    <vs-popup class="informacionformhijo" fullscreen @close="cerrarPopupFicheroMercadoVisualizar()" title="Visualización Fichero" :active.sync="popupFicheroMercadoVisualizar">
        <Visualizar_FicheroMercado v-if="popupFicheroMercadoVisualizar" :periodoSeleccionado="periodoSeleccionado" :institucion_Enviar="institucionSeleccionada" :Fichero_Array="Fichero_Array" @change="changeHandleFicheroMercadoVisualizar" />
    </vs-popup>
    <vs-popup class="informacionformhijo" @close="cerrarPopupFicheroMercadoEnviar_Aprobacion()" title="Enviar para aprobación" :active.sync="popupFicheroMercadoEnviar_Aprobacion">
        <Enviar_para_aprobacion v-if="popupFicheroMercadoEnviar_Aprobacion" :Fichero_Array="Fichero_Array" @change="changeHandleFicheroMercadoEnviar_Aprobacion" />
    </vs-popup>
    <vs-popup class="informacionformhijo" @close="cerrarPopupFicheroMercadoEnviar_Aprobacion()" title="Permitir que el asesor modifique el fichero" :active.sync="popupFicheroMercadoCambio_EstadoActivo">
        <CambioEstadoActivo v-if="popupFicheroMercadoCambio_EstadoActivo" :Fichero_Array="Fichero_Array" @change="changeHandleFicheroMercadoCambio_EstadoActivo" />
    </vs-popup>
    <!-- Nuevo Popup de Opciones de Creación -->
    <vs-popup class="informacionformhijo" @close="metodoEjecucionGlobalDetalle()" title="Opciones de Creación" :active.sync="popupFormasCreacion" fullscreen>
        <Formas_CreacionFichero v-if="popupFormasCreacion" :institucion_Enviar="institucionSeleccionada" :periodoSeleccionado="periodoSeleccionado" @change="changeHandleFormasCreacion" />
    </vs-popup>
    <!-- SECCION RECHAZO -->
    <vs-popup class="informacionformhijodehijo" @close="cerrarPopupFicheroMercadoEliminar()" title="Eliminar Fichero de Mercado" :active.sync="popupActivo_EliminarFichero">
        <Eliminar_FicheroMercado v-if="popupActivo_EliminarFichero" :Fichero_Array="Fichero_Array" @change="changeHandleEliminar_FicheroMercado" />
    </vs-popup>

</div>
</template>

<script>
const Nuevo_Edit_FicheroMercado = () => import('@/views/pedidos2/fichero_mercado/Crear_Editar_Fichero.vue');
const Visualizar_FicheroMercado = () => import('@/views/pedidos2/fichero_mercado/Visualizar_Fichero.vue');
const Enviar_para_aprobacion = () => import('@/views/pedidos2/fichero_mercado/Enviar_para_aprobacion.vue');
const CambioEstadoActivo = () => import('@/views/pedidos2/fichero_mercado/CambioEstadoActivo.vue');
const Formas_CreacionFichero = () => import('@/views/pedidos2/fichero_mercado/Formas_CreacionFichero.vue');
const Eliminar_FicheroMercado = () => import("@/views/pedidos2/fichero_mercado/Eliminar_Fichero_Mercado.vue");
import PopupHistoryMixin from '@/mixins/PopupHistoryMixin'
import {
    mapState
} from "vuex";
export default {
    mixins: [PopupHistoryMixin],
    data() {
        return {
            tieneficheroExistente: false, // Indica si ya existe un fichero para esta institución
            popupFicheroMercado: false, // Controla el popup del formulario
            popupFicheroMercadoVisualizar: false,
            popupFicheroMercadoEnviar_Aprobacion: false,
            popupFicheroMercadoCambio_EstadoActivo: false,
            popupFormasCreacion: false, // Control para el nuevo popup
            popupActivo_EliminarFichero: false, // Control para el popup de eliminar fichero
            institucionSeleccionada: {},
            verificarcrear_actualizar: '',
            Fichero_Array: [],
            isrunLoading_metodoEjecucionGlobalDetalle: false,
            isHistoryBack: false, // Control para historial
            notifyDivFichero: null, // Referencia al div de notificación
            overlayFichero: null // Referencia al overlay de fondo
        };
    },
    props: {
        Info_Institucion: {
            type: Object,
            default: () => ({}),
        },
        periodoSeleccionado: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        themeMode() {
            return this.$store.state.theme === 'dark';
        },
        ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'userAsesor', 'groupFacturador']),
    },
    components: {
        Nuevo_Edit_FicheroMercado,
        Visualizar_FicheroMercado,
        Enviar_para_aprobacion,
        CambioEstadoActivo,
        Formas_CreacionFichero,
        Eliminar_FicheroMercado
    },
    created() {
        // IMPORTANTE: Registrar popups ANTES de mounted para que el watcher se active correctamente
        this.registerPopupHistory('popupFormasCreacion');
        this.registerPopupHistory('popupActivo_EliminarFichero');
        this.registerPopupHistory('popupFicheroMercadoVisualizar');
    },
    mounted() {
        this.institucionSeleccionada = this.Info_Institucion;
        this.metodoEjecucionGlobalDetalle();
        // Escuchar el evento popstate para detectar navegación del navegador
        window.addEventListener('popstate', this.handlePopState);
    },
    beforeDestroy() {
        // Limpiar el listener
        window.removeEventListener('popstate', this.handlePopState);
        // Restaurar el scroll del body si el popup está abierto
        if (this.popupFicheroMercado) {
            document.body.style.overscrollBehavior = '';
            document.body.style.touchAction = '';
        }
        // Limpiar el mensaje de notificación si existe
        this.ocultarMensajeGenerandoFichero();
    },
    watch: {
        // Vigilar cambios en el estado del popup
        popupFicheroMercado(newVal) {
            if (newVal) {
                // Cuando el popup se abre
                // 1. Prevenir gestos de navegación horizontal
                document.body.style.overscrollBehavior = 'none';
                document.body.style.touchAction = 'pan-y pinch-zoom';

                // Evitar duplicar
                if (history.state && history.state.popupFicheroMercado) {
                    this.isHistoryBack = false;
                    return;
                }

                // 2. Agregar una entrada al historial para detectar el botón atrás
                // Usamos ...history.state por consistencia, aunque aquí suele ser el inicio
                let newState = {
                    ...history.state,
                    popupFicheroMercado: true
                };
                window.history.pushState(newState, '');

                this.isHistoryBack = false;
            } else {
                // Cuando el popup se cierra, restaurar el comportamiento normal
                document.body.style.overscrollBehavior = '';
                document.body.style.touchAction = '';

                // Si se cierra y NO fue por botón atrás (fue por código/emit), retrocedemos historial
                if (!this.isHistoryBack) {
                    window.history.back();
                    console.log('Abuelo-popup cerrado por código -> history.back() manual');
                }
                this.isHistoryBack = false;
            }
        },
        // Watch para detectar cierre de POPUPS por mixin (por botón atrás o programático)
        popupFormasCreacion(newVal) {
            if (!newVal) {
                // El popup se cerró - ejecutar lógica de limpieza/actualización
                console.log('🔴 popupFormasCreacion cerrado, ejecutando cleanup...');
                this.metodoEjecucionGlobalDetalle();
            }
        },
        popupActivo_EliminarFichero(newVal) {
            if (!newVal) {
                // El popup se cerró - ejecutar lógica de limpieza/actualización
                console.log('🔴 popupActivo_EliminarFichero cerrado, ejecutando cleanup...');
                this.cerrarPopupFicheroMercadoEliminar();
            }
        },
        popupFicheroMercadoVisualizar(newVal) {
            if (!newVal) {
                // El popup se cerró - ejecutar lógica de limpieza/actualización
                console.log('🔴 popupFicheroMercadoVisualizar cerrado, ejecutando cleanup...');
                this.cerrarPopupFicheroMercadoVisualizar();
            }
        }
    },
    methods: {
        // Manejar el evento popstate (botón atrás/adelante del navegador)
        handlePopState(event) {
            this.isHistoryBack = true;

            // Si el popup está abierto
            if (this.popupFicheroMercado) {
                // Si el estado del historial dice que este popup debe estar abierto,
                // significa que regresamos de un nivel más profundo (un sub-popup hijo se cerró),
                // así que NO cerramos este popup padre.
                if (event.state && event.state.popupFicheroMercado) {
                    console.log('🔙 Regresamos al estado del popup padre (se cerró un hijo)');
                    return;
                }

                // Si no hay state o es diferente, cerramos el popup
                this.popupFicheroMercado = false;
                document.body.style.overscrollBehavior = '';
                document.body.style.touchAction = '';
                this.metodoEjecucionGlobalDetalle();
                console.log('✅ Popup cerrado por botón atrás del navegador');
            } else {
                this.isHistoryBack = false;
            }
        },
        async metodoEjecucionGlobalDetalle() {
            let me = this;
            try {
                me.isrunLoading_metodoEjecucionGlobalDetalle = true;
                me.$vs.loading();
                await me.getVerificar_Existencia_Fichero();
                await me.cargarInformacionCompleta();
                me.isrunLoading_metodoEjecucionGlobalDetalle = false
                me.$vs.loading.close();
            } catch (error) {
                console.error('Error en metodoEjecucionGlobal:', error);
                me.$vs.loading.close();
            }
        },
        getVerificar_Existencia_Fichero() {
            return new Promise((resolve, reject) => {
                let enviardata = {
                    action: 'Verificar_GetFicheroSeleccionado_Existencia',
                    idInstitucion: this.institucionSeleccionada.idInstitucion,
                    periodo_id: this.periodoSeleccionado.idperiodoescolar
                };
                this.$http.get(this.$server_url + 'Procesar_MetodosGet_Fichero_MercadoController', {
                        params: enviardata
                    })
                    .then(response => {
                        this.$vs.loading.close();
                        if (response.data && response.data.length > 0) {
                            this.Fichero_Array = response.data;
                            this.tieneficheroExistente = true;
                            resolve();
                        } else {
                            this.tieneficheroExistente = false;
                            resolve();
                        }
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        console.error('Error al buscar instituciones:', error);
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Error al buscar los datos',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                        reject("getVerificar_Existencia_Fichero", error);
                    });
            });
        },
        // Cargar información completa de la institución
        async cargarInformacionCompleta() {
            let me = this;
            return new Promise((resolve, reject) => {
                me.$vs.loading();
                let idInstitucion = this.institucionSeleccionada.idInstitucion;
                // console.log('Cargando información completa de la institución:', idInstitucion);

                // Para método GET, usar parámetros en la URL
                let url = `traerInstitucionFichero?institucion_idInstitucion=${idInstitucion}`;

                this.$http.get(this.$server_url + url)
                    .then(response => {
                        // console.log('Información completa de la institución:', response.data);

                        if (response.data && response.data.length > 0) {
                            const institucionCompleta = response.data[0];

                            // Actualizar la institución seleccionada con toda la información
                            me.institucionSeleccionada = {
                                ...me.institucionSeleccionada,
                                ...institucionCompleta
                            };
                            resolve();
                            // console.log('✅ Institución actualizada con información completa:', me.institucionSeleccionada);
                            me.$vs.loading.close();
                        }
                    })
                    .catch(error => {
                        console.error('Error al cargar información completa:', error);
                        me.$vs.loading.close();
                        reject("cargarInformacionCompleta", error);
                        // No mostrar error al usuario, continuar con la información básica
                    });
            });
        },
        Visualizar_Fichero() {
            this.popupFicheroMercadoVisualizar = true
        },
        Eliminar_Fichero() {
            this.popupActivo_EliminarFichero = true
        },
        EnviarParaAprobacion() {
            this.popupFicheroMercadoEnviar_Aprobacion = true
        },
        Cambio_Estado_Activo() {
            this.popupFicheroMercadoCambio_EstadoActivo = true
        },
        // Regresar al buscador y limpiar todo
        regresarABuscador() {
            // Notificación opcional
            this.$vs.notify({
                title: 'Búsqueda',
                text: 'Puede buscar una nueva institución',
                color: 'primary',
                iconPack: 'feather',
                icon: 'icon-search'
            });
        },
        // Abrir opciones de creación
        abrirOpcionesCreacion() {
            this.popupFormasCreacion = true;
        },
        // Manejador centralizado para opciones de creación
        async changeHandleFormasCreacion(e) {
            let me = this;
            if (e.tipo === 'crear_vacio') {
                me.popupFormasCreacion = false;
                me.verificarcrear_actualizar = 'crear';
                // Mostrar mensaje de espera
                me.mostrarMensajeGenerandoFichero();
                // Esperar a que metodoEjecucionGlobalDetalle termine antes de crear el fichero
                await me.metodoEjecucionGlobalDetalle();
                // Esperar 700 milisegundos adicionales para que el loading se cierre y renderice correctamente
                setTimeout(() => {
                    me.ocultarMensajeGenerandoFichero();
                    me.crearNuevoFichero();
                }, 1000);
            } else if (e.tipo === 'fichero_copiado') {
                me.popupFormasCreacion = false;
                // Mostrar mensaje de espera
                me.mostrarMensajeGenerandoFichero();
                await me.metodoEjecucionGlobalDetalle();
                // Esperar 700 milisegundos adicionales para que el loading se cierre y renderice correctamente
                setTimeout(() => {
                    me.ocultarMensajeGenerandoFichero();
                    me.verificarcrear_actualizar = 'editar';
                    me.Actualizar_Fichero();
                }, 1000);
            } else {
                await me.metodoEjecucionGlobalDetalle();
                console.log("Emit no recibido");
            }
        },
        changeHandleEliminar_FicheroMercado(e) {
          let me = this;
            // console.log("realizarcchangeinicio")
            if (e.verificarficheromercado_Eliminar == 1) {
                console.log("Emit recibido por eliminado.");
                me.popupActivo_EliminarFichero = false;
                // this.Traer_Instituciones_Fichero_Verificacion();
            } else if (e.verificarficheromercado_Eliminar == 2) {
                console.log("Emit recibido por cancelado.");
                me.popupActivo_EliminarFichero = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        // Mostrar mensaje de generación de fichero
        mostrarMensajeGenerandoFichero() {
            // Crear el overlay de fondo si no existe
            if (!this.overlayFichero) {
                const overlay = document.createElement('div');
                overlay.id = 'overlayFicheroGeneracion';
                overlay.style.position = 'fixed';
                overlay.style.top = '0';
                overlay.style.left = '0';
                overlay.style.width = '100%';
                overlay.style.height = '100%';
                overlay.style.backgroundColor = 'rgba(128, 128, 128, 0.5)'; // Fondo gris semitransparente
                overlay.style.zIndex = '99999998'; // Justo debajo del mensaje
                overlay.style.display = 'block';

                document.body.appendChild(overlay);
                this.overlayFichero = overlay;
            }

            // Crear el div para la notificación si no existe
            if (!this.notifyDivFichero) {
                const notifyDiv = document.createElement('div');
                notifyDiv.id = 'notifyFicheroGeneracion';
                notifyDiv.style.position = 'fixed';
                notifyDiv.style.top = '50%';
                notifyDiv.style.left = '50%';
                notifyDiv.style.transform = 'translate(-50%, -50%)';
                notifyDiv.style.backgroundColor = 'rgba(0, 0, 0, 0.85)';
                notifyDiv.style.color = '#fff';
                notifyDiv.style.borderRadius = '8px';
                notifyDiv.style.padding = '25px 35px';
                notifyDiv.style.zIndex = '99999999';
                notifyDiv.style.display = 'flex';
                notifyDiv.style.alignItems = 'center';
                notifyDiv.style.justifyContent = 'center';
                notifyDiv.style.fontSize = '16px';
                notifyDiv.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
                notifyDiv.innerHTML = `
                    <span style="margin-right: 12px; font-size: 20px;">⏳</span>
                    <span>Espere por favor, se está generando su fichero...</span>
                `;

                document.body.appendChild(notifyDiv);
                this.notifyDivFichero = notifyDiv;
            }

            // Mostrar ambos elementos
            this.overlayFichero.style.display = 'block';
            this.notifyDivFichero.style.display = 'flex';
        },
        // Ocultar mensaje de generación de fichero
        ocultarMensajeGenerandoFichero() {
            // Ocultar y eliminar el overlay de fondo
            if (this.overlayFichero) {
                this.overlayFichero.style.display = 'none';
                document.body.removeChild(this.overlayFichero);
                this.overlayFichero = null;
            }

            // Ocultar y eliminar el mensaje
            if (this.notifyDivFichero) {
                this.notifyDivFichero.style.display = 'none';
                document.body.removeChild(this.notifyDivFichero);
                this.notifyDivFichero = null;
            }
        },
        // Crear nuevo fichero
        crearNuevoFichero() {
            this.popupFicheroMercado = true;
            // this.$vs.notify({
            //     title: 'Nuevo Fichero',
            //     text: 'Creando un nuevo fichero de mercado con datos sugeridos',
            //     color: 'primary',
            //     iconPack: 'feather',
            //     icon: 'icon-plus'
            // });
        },
        // Editar fichero existente
        Actualizar_Fichero() {
            this.popupFicheroMercado = true;
            // Cargar los datos existentes
            this.$vs.notify({
                title: 'Actualizar Fichero',
                text: 'Actualizar fichero de mercado.',
                color: 'primary',
                iconPack: 'feather',
                icon: 'icon-plus'
            });
        },
        // Cerrar popup del fichero
        cerrarPopupFicheroMercado(forzarCerrar = false) {
            if (forzarCerrar) {
                // Cierre permitido (clic en la X)
                this.popupFicheroMercado = false;
                this.metodoEjecucionGlobalDetalle();
            } else {
                // Evita cierre por clic fuera
                this.popupFicheroMercado = true;
            }
        },
        cerrarPopupFicheroMercadoVisualizar() {
            this.popupFicheroMercadoVisualizar = false;
            this.metodoEjecucionGlobalDetalle();
        },
        cerrarPopupFicheroMercadoEnviar_Aprobacion() {
            this.popupFicheroMercadoEnviar_Aprobacion = false;
        },
        cerrarPopupFicheroMercadoEliminar() {
            this.popupActivo_EliminarFichero = false;
            this.metodoEjecucionGlobalDetalle();
        },
        changeHandleNuevoActualizar_FicheroMercado(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemitsaveandedit); // Debería imprimir 1
            if (e.verificacionemitsaveandedit == 1) {
                console.log("Emit recibido por guardado.");
                me.popupFicheroMercado = false;
                this.metodoEjecucionGlobalDetalle();
            } else if (e.verificacionemitsaveandedit == 2) {
                console.log("Emit recibido por cancelado.");
                me.popupFicheroMercado = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        changeHandleFicheroMercadoVisualizar(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            me.metodoEjecucionGlobalDetalle();
            if (e.verificarficheromercadovisualizar == 1) {
                console.log("Emit recibido por guardado.");
                me.popupFicheroMercadoVisualizar = false;
            } else if (e.verificarficheromercadovisualizar == 2) {
                console.log("Emit recibido por cancelar.");
                me.popupFicheroMercadoVisualizar = false;
            } else if (e.verificarficheromercadovisualizar == 3) {
                console.log("Emit recibido por aprobacion.");
                me.popupFicheroMercadoVisualizar = false;
            } else if (e.verificarficheromercadovisualizar == 4) {
                console.log("Emit recibido por devolución.");
                me.popupFicheroMercadoVisualizar = false;
            } else if (e.verificarficheromercadovisualizar == 5) {
                console.log("Emit recibido por enviado para aprobacion.");
                me.popupFicheroMercadoVisualizar = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        changeHandleFicheroMercadoEnviar_Aprobacion(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarficheromercado_Aprobacion == 1) {
                console.log("Emit recibido por guardado.");
                me.popupFicheroMercadoEnviar_Aprobacion = false;
                this.metodoEjecucionGlobalDetalle();
            } else if (e.verificarficheromercado_Aprobacion == 2) {
                console.log("Emit recibido por cancelar.");
                me.popupFicheroMercadoEnviar_Aprobacion = false;
                this.metodoEjecucionGlobalDetalle();
            } else {
                console.log("Emit no recibido");
            }
        },

        changeHandleFicheroMercadoCambio_EstadoActivo(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarficheromercado_CambioEstado == 1) {
                console.log("Emit recibido por guardado.");
                me.popupFicheroMercadoCambio_EstadoActivo = false;
                this.metodoEjecucionGlobalDetalle();
            } else if (e.verificarficheromercado_CambioEstado == 2) {
                console.log("Emit recibido por cancelar.");
                me.popupFicheroMercadoCambio_EstadoActivo = false;
                this.metodoEjecucionGlobalDetalle();
            } else {
                console.log("Emit no recibido");
            }
        },
    }
};
</script>

<style scoped>
.informacionformhijo {
    z-index: 51001;
    /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
    /* position: fixed; */
    /* Asegúrate de que la posición sea adecuada */

    /* Prevenir gestos de navegación horizontal (swipe) */
    overscroll-behavior-x: none;
    touch-action: pan-y pinch-zoom;
}

.hide-close .vs-popup--close {
    display: none;
}

/* Prevenir gestos de navegación en el contenido del popup */
.hide-close>>>* {
    overscroll-behavior-x: none;
}

.custom-popup-close {
    position: absolute;
    top: 8px;
    right: 10px;
    width: 35px;
    /* ancho del botón */
    height: 35px;
    /* alto del botón */
    background: #FFFFFF;
    /* fondo blanco */
    border: 1px solid #999;
    /* borde tipo plomo, grosor visible */
    border-radius: 10px;
    /* completamente redondo */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-weight: bold;
    cursor: pointer;
    z-index: 1000;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    /* sombra ligera */
    transition: all 0.2s;
    color: #333;
    /* color de la X */
}

.custom-popup-close:hover {
    background: #f0f0f0;
    /* fondo al pasar el mouse */
    border-color: #666;
    /* borde más oscuro al hover */
    color: #000;
    /* X más visible */
}

/* Responsive */
@media (max-width: 768px) {
    .custom-popup-close {
        width: 35px;
        height: 35px;
        font-size: 20px;
        top: 8px;
        right: 8px;
    }
}

@media (max-width: 480px) {
    .custom-popup-close {
        width: 30px;
        height: 30px;
        font-size: 18px;
        top: 6px;
        right: 6px;
    }
}
</style>
